const techs = {
    java: {
        name: "Java",
        icon: "https://files.wida.dev/icons/java.svg"
    },
    kotlin: {
        name: "Kotlin",
        icon: "https://files.wida.dev/icons/kotlin.svg"
    },
    fabric: {
        name: "Fabric",
        icon: "https://files.wida.dev/icons/fabricmc.svg"
    },
    paper: {
        name: "Paper",
        icon: "https://files.wida.dev/icons/papermc.svg"
    },
    github: {
        name: "Github",
        icon: "https://files.wida.dev/icons/github.svg"
    },
    modrinth: {
        name: "Modrinth",
        icon: "https://files.wida.dev/icons/modrinth.svg"
    },
}
const Data = {
    sillyFaces: ["(*^ω^)", "(o^▽^o)", "＼(≧▽≦)／", "(¬‿¬ )", "(>.<)", "(•⩊•)"],
    motos: {
        default: [
            () => <>Also try <a href="http://proximity.website">proximity.website</a></>,
            () => <>meow paww purrr :33</>,
            () => <>Usagi so tuff</>,
            () => <>U u-wa-wa-uwa</>,
            () => <>Major Gooner, reporting for booty</>,
            () => <>Mythical reel pull</>,
            () => <>Una yaha yaha</>,
            () => <>Hi I love you</>,
            //() => <>My mind is full of Chiikawa</>,
            () => <>Heh, minor 🤤🎹🎵</>,
            () => <>Hello vro 💙</>,
            //() => <>Check out our new Minecraft SMP: <span className="underline">tntsurvival.wida.dev</span></>,,
        ],
        specials: {
            "1/1": () => <>Happy New Year 🎉</>,
            "30/4": () => <>🇻🇳 Happy Reunification day 🇻🇳</>,
            "2/9": () => <>🇻🇳 Happy Independence day 🇻🇳</>,
            "29/11": () => <>🎉 It's my Birthday! 🎂</>,
        }
    },
    socials: [
        {
            name: "YouTube",
            icon: "https://files.wida.dev/icons/youtube.svg",
            link: "https://www.youtube.com/@widz_a_",
        },
        {
            name: "Twitter",
            icon: "https://files.wida.dev/icons/twitter.svg",
            link: "https://twitter.com/widz-a",
        },
        {
            name: "Instagram",
            icon: "https://files.wida.dev/icons/instagram.svg",
            link: "https://instagram.com/widz-a",
        },
        {
            name: "Discord",
            icon: "https://files.wida.dev/icons/discord.svg",
            link: "https://discord.com/users/560344584836874250",
        },
        {
            name: "Github",
            icon: "https://files.wida.dev/icons/github.svg",
            link: "https://github.com/widz-a",
        },
        {
            name: "Steam",
            icon: "https://files.wida.dev/icons/steam.svg",
            link: "https://steamcommunity.com/id/widz_a_/",
        },
    ],
    projects: [
        {
            name: "TNTActingPlugin",
            description: <>A Minecraft Plugin used in <a href="https://www.youtube.com/@explodingtnt">ExplodingTNT</a>'s Acting server.</>,
            techs: [techs.kotlin, techs.paper],
            links: [
                {
                    tech: techs.github,
                    link: "https://github.com/widz-a/TNTActingPlugin"
                },
            ]
        },
        {
            name: "Gamemode Detector",
            description: "A simple Minecraft mod that notifies you when people switch gamemode!",
            techs: [techs.java, techs.fabric],
            links: [
                {
                    tech: techs.github,
                    link: "https://github.com/widz-a/GamemodeDetector"
                },
                {
                    tech: techs.modrinth,
                    link: "https://modrinth.com/mod/gamemode-detector"
                }
            ]
        },
        {
            name: "LanProtect",
            description: "A simple Minecraft mod that blocks unauthorized players from joining LAN games exposed to the Internet.",
            techs: [techs.java, techs.fabric],
            links: [
                {
                    tech: techs.github,
                    link: "https://github.com/widz-a/LANProtect"
                },
                {
                    tech: techs.modrinth,
                    link: "https://modrinth.com/mod/lanprotect/"
                },
            ]
        },
        {
            name: "CosmicSMPRevamped",
            description: <>A Minecraft Plugin for the now shutdown CosmicSMP. Requested by <a href="https://www.youtube.com/@CosmicAnimations">Cosmic</a>.</>,
            techs: [techs.java, techs.paper],
            links: [
                {
                    tech: techs.github,
                    link: "https://github.com/widz-a/CosmicSMPRevamped"
                },
            ]
        },
        {
            name: "PNS Mod",
            description: <>A Minecraft mod that automatically <b>P</b>unch, <b>N</b>od, <b>S</b>neak. Requested by <u>Prox</u>.</>,
            techs: [techs.java, techs.kotlin, techs.fabric],
            links: [
                {
                    tech: techs.github,
                    link: "https://github.com/widz-a/pns"
                },
            ]
        }
    ]
}

export default Data